import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step11 } from '../../../../../shared/models/component-messages/mapaIN/step11';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';

@Component({
	selector: 'app-step11',
	templateUrl: './step11.component.html'
})
export class Step11Component implements OnInit {

	private LOG: LogService = new LogService(Step11Component);

	@Input() initial: Initial;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;



	@Input() uid = '';

	public step11 = new Step11();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }


	ngOnInit(): void { }

	public getUid() {
		return this.uid;
	}

	getUidRenseignements() {
		return this.uid + '_SepSep_Renseignements';
	}

	getUidEnvoi() {
		return this.uid + '_SepSep_TypeRensA_SepSep_Envoi';
	}
}
